require('./arrows-control.scss');

module.exports = {
    hideArrows: function($carousel) {
        $carousel.addClass('hide-arrows');
    },
    showArrows: function($carousel) {
        $carousel.removeClass('hide-arrows');
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/customization/arrows-control.js
// module id = 40
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17